import { observer } from 'mobx-react-lite';
import { useStore } from './store';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

export default observer(() => {
  const store = useStore();

  // const wrapRoute = (list: any = []): RouteObject[] => {
  //   const permission: string[] = get(store, 'info.permissions', []);

  //   return map(cloneDeep(list), item => {
  //     if ('permission' in item) {
  //       if (permission.includes('*:*:*')) return item;
  //       if (permission.includes(item.permission)) return item;
  //       return { ...item, Component: Page403 };
  //     } else {
  //       if (isEmpty(item.children)) {
  //         return item;
  //       } else {
  //         item.children = wrapRoute(item.children);
  //         return item;
  //       }
  //     }
  //   });
  // };

  const router = createBrowserRouter(store.routes);

  return <RouterProvider router={router} />;
});
